import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import holidays from "../../../assets/holidays.json";
import { useSelector } from "react-redux";
import { differenceInDays } from "date-fns";
import { getUserState } from "../../../redux/features/auth-slice";
import { UserRole } from "../../../redux/features/user-slice";

interface Props {
  data: any[];
  onMonthChange: (start: string, end: string) => void;
  onDetail: (value: any) => void;
}

export default function FullCalendarComponent(props: Props) {
  const { data, onMonthChange, onDetail } = props;
  const user = useSelector(getUserState).data;

  const renderEventContent = (eventInfo: any) => {
    const isManager = user?.role === UserRole.Trainer || user?.role === UserRole.Admin;
    let isUnplanned = false;

    if (isManager && eventInfo.event.extendedProps?.RequestDate) {
      const fromDate = new Date(eventInfo.event.start);
      const requestDate = new Date(eventInfo.event.extendedProps.RequestDate);
      isUnplanned = differenceInDays(fromDate, requestDate) < 30;
    }

    return (
      <i
        className={`text-xs cursor-pointer overflow-x-hidden ${
          isManager && isUnplanned ? "text-error-dark font-bold underline" : ""
        }`}
        onClick={() => onDetail(eventInfo.event.id)}
      >
        {eventInfo.event.title}
      </i>
    );
  };

  return (
    <div className="h-full overflow-y-auto"> 
      <FullCalendar
        plugins={[dayGridPlugin, interactionPlugin]}
        initialView="dayGridMonth"
        firstDay={1}
        stickyHeaderDates={true} 
        datesSet={(e) => onMonthChange(e.startStr, e.endStr)}
        events={[...data, ...holidays]}
        eventContent={renderEventContent}
        height="100%"
      />
    </div>
  );
}
